module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingTillsammans.3e869ab1.png";